"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var lodash_1 = require("lodash");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var service_1 = require("../../api/service");
var utilities_1 = require("../../utilities");
var model_1 = require("../model");
var DeSerializationService = /** @class */ (function () {
    function DeSerializationService(_kbService, _languageService, _classifierService, _dePermissionService, _deService, _auditService, zone) {
        this._kbService = _kbService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._dePermissionService = _dePermissionService;
        this._deService = _deService;
        this._auditService = _auditService;
        this.zone = zone;
        this.MAX_URL_LENGTH = 1900;
        this.classifierFieldsCache = new Map();
        this.entityFieldsCache = new Map();
        this.subEntityFieldsCache = new Map();
        this.classifierIdCache = new Map();
        this.classifierCache = new Map();
        // parent systemName key, field systemName key, child instanceId key,
        this.entityIdCache = new Map();
        this.entityCache = new Map();
        this._entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
    }
    DeSerializationService.prototype.resetCaches = function () {
        this.classifierIdCache = new Map();
        this.classifierCache = new Map();
        this.entityIdCache = new Map();
        this.entityCache = new Map();
        this.classifierFieldsCache = new Map();
        this.entityFieldsCache = new Map();
        this.subEntityFieldsCache = new Map();
    };
    /**
     * Deserializes the collection of entity items.
     * @param {string} systemName - The unique identifier for entity.
     * @param {Array.<any>} entitiesDataObservable - JSON object containing the data of the entity items.
     * @returns {Promise<Array<Promise<Entity>>>} the array of entity objects wrapped in a promise
     */
    DeSerializationService.prototype.deserializeEntities = function (systemName, entitiesDataObservable) {
        var _this = this;
        var entityFields$ = this._kbService.getMetaFields(systemName);
        var languages$ = this._languageService.getInputLanguages();
        var serviceResponse = new model_1.ServiceResponseDefault();
        return zip_1.zip(entitiesDataObservable, entityFields$, languages$).pipe(operators_1.switchMap(function (_a) {
            var entitiesDataObj = _a[0], entityFields = _a[1], languages = _a[2];
            var entitiesData = entitiesDataObj['data'];
            var entitiesMeta = entitiesDataObj['meta'];
            var entitiesTmp = entitiesData.map(function (entityData) {
                return _this._entityBuilder.createEntity(model_1.MainEntity, entityFields, entityData);
            });
            return _this.collectCompoundFields(systemName, of_1.of(entitiesTmp), entityFields).pipe(operators_1.map(function () {
                var entities = [];
                serviceResponse.setMeta(utilities_1.deserializeMeta(entitiesMeta));
                entitiesData.forEach(function (entityData) {
                    var entity = _this._entityBuilder.createEntity(model_1.MainEntity, entityFields);
                    entities.push(entity);
                    idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData);
                });
                return _this.linkCompoundFields(systemName, entities, entityFields, languages);
            }), operators_1.switchMap(function (data) {
                serviceResponse.setData(data);
                return of_1.of(serviceResponse);
            }));
        }));
    };
    DeSerializationService.prototype.deserializeMainEntity = function (systemName, entityDataObservable, fieldSystemNames, isDeleted) {
        var _this = this;
        var entityFields$ = this._kbService.getMetaFields(systemName).pipe(operators_1.map(function (fields) {
            if (fieldSystemNames && fieldSystemNames.length > 0) {
                return fields.filter(function (metaField) {
                    return fieldSystemNames.indexOf(metaField.getSystemName()) !== -1;
                });
            }
            return fields;
        }));
        var languages$ = this._languageService.getInputLanguages();
        return zip_1.zip(entityDataObservable, entityFields$, languages$).pipe(operators_1.switchMap(function (_a) {
            var data = _a[0], entityFields = _a[1], languages = _a[2];
            var entityData = data['data'] || data;
            var entity = _this._entityBuilder.createEntity(model_1.MainEntity, entityFields, entityData, isDeleted);
            return _this.collectCompoundFields(systemName, of_1.of([entity]), entityFields).pipe(operators_1.map(function () {
                var partiallyDeserialized = idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData);
                return _this.linkCompoundFields(systemName, [partiallyDeserialized], entityFields, languages).pop();
            }));
        }));
    };
    DeSerializationService.prototype.deserializeSubEntity = function (systemName, entityDataObservable) {
        var _this = this;
        var entityFields$ = this._kbService.getMetaFields(systemName);
        var languages$ = this._languageService.getInputLanguages();
        return zip_1.zip(entityDataObservable, entityFields$, languages$).pipe(operators_1.switchMap(function (_a) {
            var data = _a[0], entityFields = _a[1], languages = _a[2];
            var entityData = data['data'] || data;
            var entity = _this._entityBuilder.createEntity(model_1.SubEntity, entityFields, entityData);
            return _this.collectCompoundFields(systemName, of_1.of([entity]), entityFields).pipe(operators_1.map(function () {
                var partiallyDeserialized = idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData);
                return _this.linkCompoundFields(systemName, [partiallyDeserialized], entityFields, languages).pop();
            }));
        }));
    };
    DeSerializationService.prototype.deserializeMainEntityWithMeta = function (systemName, entityData) {
        var _this = this;
        var serviceResponse = new model_1.ServiceResponseDefault();
        if (entityData.meta.hasViewPermission === false) {
            serviceResponse.setMeta(utilities_1.deserializeMeta(entityData.meta));
            serviceResponse.setData(undefined);
            serviceResponse.hasViewPermission = false;
            return of_1.of(serviceResponse);
        }
        var entityFields$ = this._kbService.getMetaFields(systemName);
        var languagesObservable = this._languageService.getInputLanguages();
        return zip_1.zip(entityFields$, languagesObservable).pipe(operators_1.switchMap(function (_a) {
            var entityFields = _a[0], languages = _a[1];
            var entity = _this._entityBuilder.createEntity(model_1.MainEntity, entityFields, entityData.data);
            serviceResponse.setMeta(utilities_1.deserializeMeta(entityData.meta));
            return _this.collectCompoundFields(systemName, of_1.of([entity]), entityFields).pipe(operators_1.map(function () {
                var partiallyDeserialized = idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData.data);
                return _this.linkCompoundFields(systemName, [partiallyDeserialized], entityFields, languages).pop();
            }), operators_1.map(function (deserializedEntity) {
                serviceResponse.setData(deserializedEntity);
                return serviceResponse;
            }));
        }));
    };
    /**
     * Serializes the entity object.
     * @param {string} systemName - The unique identifier for the entity.
     * @param {Entity} entity - Entity object to be serialized.
     * @param {boolean} withoutPermissions
     * @returns {any} the serialized entity
     */
    DeSerializationService.prototype.serializeEntity = function (systemName, entity, withoutPermissions) {
        var _this = this;
        if (withoutPermissions === void 0) { withoutPermissions = false; }
        var entityFields;
        var languages$ = this._languageService.getInputLanguages();
        var metaFields$ = this._kbService.getMetaFields(systemName);
        return zip_1.zip(languages$, metaFields$).pipe(operators_1.switchMap(function (data) {
            entityFields = data[1];
            var hasInstanceIdField = false;
            var entityFieldsObservables = _this.getSerializedFieldsObservables(entityFields, entity, data[0]);
            entityFields.forEach(function (field) {
                if (field.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE) {
                    hasInstanceIdField = true;
                }
            });
            var permissions$;
            if (hasInstanceIdField && !withoutPermissions) {
                var instanceId = entity.getInstanceId();
                if (instanceId && entity.getId() && entity.getId() !== -1) {
                    permissions$ = _this._dePermissionService.getCategoryDePermissionsByInstance(systemName, instanceId);
                }
                else {
                    permissions$ = _this._dePermissionService.getPermissionValue(systemName, idm_authorization_client_js_1.PermissionType.ADD);
                }
            }
            else {
                permissions$ = of_1.of(undefined);
            }
            return zip_1.zip(combineLatest_1.combineLatest.apply(void 0, entityFieldsObservables).pipe(operators_1.first()), permissions$);
        }), operators_1.map(function (data) {
            return _this.makeEntityData(entityFields, data[0], data[1]);
        }));
    };
    /**
     * Serializes all the entity objects
     * @param {string} systemName - The unique identifier for the entity.
     * @param {Entity} entities - Entity objects to be serialized.
     * @param {boolean} create - whether this is for create operation or not
     * @returns {Observable<any[]>} the serialized entity
     */
    DeSerializationService.prototype.bulkSerializeEntities = function (systemName, entities, create) {
        var _this = this;
        var entityFields;
        var languages$ = this._languageService.getInputLanguages();
        var metaFields$ = this._kbService.getMetaFields(systemName);
        var permissions$ = this.getEntitiesPermissions(systemName, entities, create);
        return zip_1.zip(languages$, metaFields$, permissions$).pipe(operators_1.switchMap(function (data) {
            entityFields = data[1];
            var fieldsAndPermissions = entities.map(function (entity, index) {
                var entityFieldsObservables = _this.getSerializedFieldsObservables(entityFields, entity, data[0]);
                return zip_1.zip(combineLatest_1.combineLatest.apply(void 0, entityFieldsObservables).pipe(operators_1.first()), of_1.of(create ? data[2][0] : data[2][index]));
            });
            return zip_1.zip.apply(void 0, fieldsAndPermissions);
        }), operators_1.map(function (data) {
            return data.map(function (fieldsAndPermissions) {
                return _this.makeEntityData(entityFields, fieldsAndPermissions[0], fieldsAndPermissions[1]);
            });
        }));
    };
    DeSerializationService.prototype.linkCompoundFields = function (systemName, entities, entityFields, languages) {
        var _this = this;
        entityFields.forEach(function (field) {
            switch (field.getType()) {
                case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                    entities.forEach(function (entity) {
                        var classifierId = entity.getProperty(field.getSystemName()).value;
                        if (lodash_1.isNumber(classifierId)) {
                            var compoundCategorySystemName = field.getCompoundCategorySystemName();
                            var classifier = !lodash_1.isNil(classifierId) &&
                                _this.classifierCache.has(compoundCategorySystemName)
                                ? _this.classifierCache
                                    .get(compoundCategorySystemName)
                                    .find(function (cls) {
                                    return cls.getId() === classifierId;
                                })
                                : null;
                            entity.getProperty(field.getSystemName()).value = !lodash_1.isNil(classifier)
                                ? _this.linkCompoundFields(compoundCategorySystemName, [classifier], _this.classifierFieldsCache.get(compoundCategorySystemName), languages).pop()
                                : null;
                        }
                    });
                    break;
                }
                case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
                    entities.forEach(function (entity) {
                        var classifierIds = entity.getProperty(field.getSystemName()).value;
                        if (lodash_1.isArray(classifierIds) &&
                            !classifierIds.some(isNaN)) {
                            var compoundCategorySystemName = field.getCompoundCategorySystemName();
                            var classifiers = _this.classifierCache.has(compoundCategorySystemName)
                                ? _this.classifierCache
                                    .get(compoundCategorySystemName)
                                    .filter(function (cls) {
                                    return classifierIds.indexOf(cls.getId()) !== -1;
                                })
                                : [];
                            entity.getProperty(field.getSystemName()).value = !lodash_1.isEmpty(classifiers)
                                ? _this.linkCompoundFields(compoundCategorySystemName, classifiers, _this.classifierFieldsCache.get(compoundCategorySystemName), languages)
                                : [];
                        }
                    });
                    break;
                }
                case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                    entities.forEach(function (entity) {
                        var entityInstanceId = entity.getProperty(field.getSystemName()).value;
                        if (lodash_1.isNumber(entityInstanceId)) {
                            var compoundCategorySystemName = field.getCompoundCategorySystemName();
                            var entityInstance = null;
                            if (_this.entityCache.has(systemName) &&
                                _this.entityCache
                                    .get(systemName)
                                    .has(field.getSystemName())) {
                                entityInstance = _this.entityCache
                                    .get(systemName)
                                    .get(field.getSystemName())
                                    .find(function (ent) {
                                    return ent.getInstanceId() ===
                                        entityInstanceId;
                                });
                            }
                            if (!lodash_1.isNil(entityInstance)) {
                                entity.getProperty(field.getSystemName()).value = _this.linkCompoundFields(compoundCategorySystemName, [entityInstance], _this.entityFieldsCache
                                    .get(systemName)
                                    .get(field.getSystemName()), languages).pop();
                            }
                        }
                    });
                    break;
                }
                case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY: {
                    entities.forEach(function (entity) {
                        var rawSubEntities = entity.getProperty(field.getSystemName()).value;
                        var compoundCategorySystemName = field.getCompoundCategorySystemName();
                        if (_this.subEntityFieldsCache.has(compoundCategorySystemName)) {
                            var subEntities = rawSubEntities.map(function (rawSub) {
                                return idm_de_core_frontend_1.deserializeSimpleFields(_this.subEntityFieldsCache.get(compoundCategorySystemName), languages, _this._entityBuilder.createEntity(model_1.SubEntity, _this.subEntityFieldsCache.get(compoundCategorySystemName)), rawSub);
                            });
                            entity.getProperty(field.getSystemName()).value = _this.linkCompoundFields(compoundCategorySystemName, subEntities, _this.subEntityFieldsCache.get(compoundCategorySystemName), languages);
                        }
                    });
                    break;
                }
            }
        });
        return entities;
    };
    DeSerializationService.prototype.extractFromCompoundField = function (systemName, field, flatEntity, newClassifierIds, newEntityIds, newSubEntities) {
        var compoundCategorySystemName = field.getCompoundCategorySystemName();
        switch (field.getType()) {
            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
            case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                var classifierId = flatEntity.getProperty(field.getSystemName()).value;
                if (lodash_1.isNumber(classifierId)) {
                    mapCheckAddSet(newClassifierIds, this.classifierIdCache, compoundCategorySystemName, classifierId);
                    mapAddSet(this.classifierIdCache, compoundCategorySystemName, classifierId);
                }
                break;
            }
            case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
                var classifierIds = flatEntity.getProperty(field.getSystemName()).value;
                if (lodash_1.isArray(classifierIds) && !classifierIds.some(isNaN)) {
                    mapCheckAddSet(newClassifierIds, this.classifierIdCache, compoundCategorySystemName, classifierIds);
                    mapAddSet(this.classifierIdCache, compoundCategorySystemName, classifierIds);
                }
                break;
            }
            case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                var entityInstanceId = flatEntity.getProperty(field.getSystemName()).value;
                if (lodash_1.isNumber(entityInstanceId)) {
                    mapCheckAddSet(newEntityIds, getOrDefault(this.entityIdCache, systemName, function () { return new Map(); }), field.getSystemName(), entityInstanceId);
                    mapAddSet(getOrDefault(this.entityIdCache, systemName, function () { return new Map(); }), field.getSystemName(), entityInstanceId);
                }
                break;
            }
            case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY: {
                mapAddArray(newSubEntities, compoundCategorySystemName, flatEntity.getProperty(field.getSystemName())
                    .value);
                break;
            }
        }
    };
    DeSerializationService.prototype.collectCompoundFields = function (systemName, flatEntity$, fields) {
        var _this = this;
        return flatEntity$.pipe(operators_1.switchMap(function (flatEntities) {
            var newClassifierIds = new Map();
            var newEntityIds = new Map();
            var newSubEntities = new Map();
            fields.forEach(function (field) {
                flatEntities.forEach(function (flatEntity) {
                    var fieldValue = flatEntity.getProperty(field.getSystemName()).value;
                    if (!lodash_1.isNil(fieldValue) ||
                        (lodash_1.isArray(fieldValue) && !lodash_1.isEmpty(fieldValue))) {
                        _this.extractFromCompoundField(systemName, field, flatEntity, newClassifierIds, newEntityIds, newSubEntities);
                    }
                });
            });
            var clsCalls$ = Array.from(newClassifierIds.keys()).map(function (category) {
                var clsFields$;
                if (_this.classifierFieldsCache.has(category)) {
                    clsFields$ = of_1.of(_this.classifierFieldsCache.get(category));
                }
                else {
                    clsFields$ = _this._kbService.getMetaFields(category);
                }
                return clsFields$.pipe(operators_1.switchMap(function (clsFields) {
                    var cls$ = _this._classifierService
                        .loadClassifiersByIds(category, Array.from(newClassifierIds.get(category)))
                        .pipe(operators_1.map(function (classifiers) {
                        var cls = classifiers.getData();
                        mapAddArray(_this.classifierCache, category, cls);
                        return cls;
                    }));
                    if (!_this.classifierFieldsCache.has(category)) {
                        _this.classifierFieldsCache.set(category, clsFields);
                    }
                    return _this.collectCompoundFields(category, cls$, clsFields);
                }));
            });
            var entityCalls$ = Array.from(newEntityIds.keys()).map(function (currentMainEntityFieldName) {
                var currentMainEntityField = fields.find(function (field) {
                    return field.getSystemName() ===
                        currentMainEntityFieldName;
                });
                var entityFields$;
                if (_this.entityFieldsCache.has(systemName) &&
                    _this.entityFieldsCache
                        .get(systemName)
                        .has(currentMainEntityFieldName)) {
                    entityFields$ = of_1.of(_this.entityFieldsCache
                        .get(systemName)
                        .get(currentMainEntityFieldName));
                }
                else {
                    entityFields$ = _this._kbService
                        .getMainEntityMetaFields(systemName, currentMainEntityFieldName)
                        .pipe(operators_1.switchMap(function (flds) {
                        return flds.length > 0
                            ? of_1.of(flds)
                            : _this._kbService.getMetaFields(currentMainEntityField.getCompoundCategorySystemName());
                    }));
                }
                return entityFields$.pipe(operators_1.switchMap(function (entityFields) {
                    var entityIds = Array.from(newEntityIds.get(currentMainEntityFieldName));
                    var fieldSystemNames = entityFields.map(function (field) { return field.getSystemName(); });
                    return _this._deService
                        .getEntitiesByIdsRaw(currentMainEntityField.getCompoundCategorySystemName(), entityIds, false, fieldSystemNames)
                        .pipe(operators_1.switchMap(function (entitiesData) {
                        var newEntities = entitiesData.data.map(function (data) {
                            return _this._entityBuilder.createEntity(model_1.MainEntity, entityFields, data);
                        });
                        var notLoadedIds = entityIds.filter(function (id) {
                            return !newEntities.some(function (newEntity) {
                                return newEntity.getInstanceId() ===
                                    id;
                            });
                        });
                        newEntities.push.apply(newEntities, notLoadedIds.map(function (id) {
                            return _this.entityWithNoViewPermission(entityFields, id);
                        }));
                        getOrDefault(_this.entityFieldsCache, systemName, function () {
                            return new Map();
                        }).set(currentMainEntityFieldName, entityFields);
                        mapAddArray(getOrDefault(_this.entityCache, systemName, function () {
                            return new Map();
                        }), currentMainEntityFieldName, newEntities);
                        return _this.collectCompoundFields(currentMainEntityField.getCompoundCategorySystemName(), of_1.of(newEntities), entityFields);
                    }));
                }));
            });
            var subCalls$ = Array.from(newSubEntities.keys()).map(function (category) {
                var subEntityFields$;
                if (_this.subEntityFieldsCache.has(category)) {
                    subEntityFields$ = of_1.of(_this.subEntityFieldsCache.get(category));
                }
                else {
                    subEntityFields$ = _this._kbService.getMetaFields(category);
                }
                return subEntityFields$.pipe(operators_1.switchMap(function (subFields) {
                    var subs = newSubEntities
                        .get(category)
                        .map(function (sub) {
                        if (!_this.subEntityFieldsCache.has(category)) {
                            _this.subEntityFieldsCache.set(category, subFields);
                        }
                        return _this._entityBuilder.createEntity(model_1.SubEntity, subFields, sub);
                    });
                    return _this.collectCompoundFields(category, of_1.of(subs), subFields);
                }));
            });
            var allCall$ = subCalls$.concat(clsCalls$, entityCalls$);
            return allCall$.length > 0 ? zip_1.zip.apply(void 0, allCall$) : of_1.of(void 0);
        }), operators_1.catchError(function (err) {
            console.error(err);
            return of_1.of(void 0);
        }));
    };
    /**
     * Deserializes a single entity item.
     * @param {string} systemName - The unique identifier for entity.
     * @param {any} entityDataObservable - JSON object containing data for a single entity item.
     * @param {Entity} entity
     * @param {Array<any>} entityFields
     * @returns {Promise<Entity>} entity object wrapped in a promise
     */
    // private deserializeEntity(
    //     systemName: string,
    //     entityDataObservable: Observable<any>,
    //     entity: Entity,
    //     entityFields: any[],
    //     shouldEnterZone = false
    // ): Observable<any> {
    //     let observable = entityDataObservable.pipe(
    //         switchMap(data => {
    //             const entityData = data.data || data;
    //             const languagesObservable: Observable<any> = this._languageService.getInputLanguages();
    //             return languagesObservable.pipe(
    //                 map((languages: any) => {
    //                     return deserializeSimpleFields(
    //                         entityFields,
    //                         languages,
    //                         entity,
    //                         entityData
    //                     );
    //                 })
    //             );
    //         }),
    //         switchMap((deserializedEntity: any) => {
    //             return this.deserializeEntityCompoundFields(
    //                 entityFields,
    //                 [deserializedEntity],
    //                 systemName
    //             ).pipe(
    //                 switchMap((deserializedEntities: any) => {
    //                     return of(deserializedEntities[0]);
    //                 })
    //             );
    //         })
    //     );
    //     if (shouldEnterZone) {
    //         observable = observable.pipe(
    //             observeOn(enterZone(this.zone, async))
    //         );
    //     }
    //     return observable;
    // }
    /**
     * Serializes the list of SubEntity objects.
     * @param {string} systemName - The unique identifier for the subEntity.
     * @param {Array<SubEntity>} subEntities - List of SubEntities to be serialized.
     * @returns {any} the serialized subEntities
     */
    DeSerializationService.prototype.serializeSubEntities = function (systemName, subEntities) {
        var _this = this;
        var subEntitiesObservables = subEntities.map(function (subEntity) {
            return _this.serializeEntity(systemName, subEntity);
        });
        return zip_1.zip.apply(void 0, subEntitiesObservables);
    };
    // private deserializeSubEntities(
    //     systemName: string,
    //     entitiesData: any[]
    // ): Observable<Entity[]> {
    //     const entityFieldsObservable = this._kbService.getMetaFields(
    //         systemName
    //     );
    //     const languagesObservable = this._languageService.getInputLanguages();
    //     return zip(entityFieldsObservable, languagesObservable).pipe(
    //         switchMap((data: any) => {
    //             const entityFields = data[0];
    //             const languages = data[1];
    //             const partiallyDeserializedEntities: Entity[] = entitiesData.map(
    //                 (entityData: any) => {
    //                     const entity: Entity = this._entityBuilder.createEntity<
    //                         SubEntity
    //                     >(SubEntity, entityFields);
    //                     return deserializeSimpleFields(
    //                         entityFields,
    //                         languages,
    //                         entity,
    //                         entityData
    //                     );
    //                 }
    //             );
    //             return this.deserializeEntityCompoundFields(
    //                 entityFields,
    //                 partiallyDeserializedEntities,
    //                 systemName
    //             );
    //         })
    //     );
    // }
    // private deserializeEntityCompoundFields(
    //     entityFields: MetaField[],
    //     entities: Entity[],
    //     categorySystemName?: string
    // ): Observable<Entity[]> {
    //     const entityCompoundFields = entityFields
    //         .filter(isCompoundField)
    //         .filter(field => {
    //             return entities.some((entity: Entity) => {
    //                 return isFieldValueNotEmpty(field, entity);
    //             });
    //         });
    //     if (entityCompoundFields.length > 0) {
    //         const entityNonSimpleFieldObservables = entityCompoundFields.map(
    //             (field: MetaField) => {
    //                 return this.deserializeCompoundField(
    //                     field,
    //                     entities,
    //                     categorySystemName
    //                 );
    //             }
    //         );
    //         return zip(...entityNonSimpleFieldObservables).pipe(
    //             map(fieldValues => {
    //                 entityCompoundFields.forEach(
    //                     (field: MetaField, index: number) => {
    //                         entities.forEach(
    //                             (entity: Entity, entityIndex: number) => {
    //                                 if (fieldValues[index][entityIndex]) {
    //                                     entities[entityIndex].getProperty(
    //                                         field.getSystemName()
    //                                     ).value =
    //                                         fieldValues[index][entityIndex];
    //                                 } else {
    //                                     console.log(
    //                                         `There is no such compound field with id: ${
    //                                             entities[
    //                                                 entityIndex
    //                                                 ].getProperty(
    //                                                 field.getSystemName()
    //                                             ).value
    //                                         }`
    //                                     );
    //                                     entities[entityIndex].getProperty(
    //                                         field.getSystemName()
    //                                     ).value = null;
    //                                 }
    //                             }
    //                         );
    //                     }
    //                 );
    //                 return entities;
    //             })
    //         );
    //     } else {
    //         return of(entities);
    //     }
    // }
    // private deserializeCompoundField(
    //     field: MetaField,
    //     entities: Entity[],
    //     categorySystemName?: string
    // ): Observable<any[]> {
    //     const fieldType: MetaFieldType = field.getType();
    //     switch (fieldType) {
    //         case MetaFieldType.CLASSIFIER:
    //         case MetaFieldType.WORKFLOW_STATE: {
    //             const classifierIds: number[] = entities.map(entity => entity.getProperty<number>(field.getSystemName()).value);
    //             const result = this.classifierCache.get(field.getCompoundCategorySystemName())
    //                 .filter(classifier => classifierIds.indexOf(classifier.getId()) > -1);
    //             return of(result);
    //         }
    //         case MetaFieldType.MULTI_SELECT: {
    //             const classifierIdsList: number[][] = entities.map(entity => entity.getProperty<number[]>(field.getSystemName()).value);
    //
    //             const result = classifierIdsList.map((classifierIds, index) =>
    //                 this.classifierCache.get(field.getCompoundCategorySystemName())
    //                     .filter(classifier => classifierIds.indexOf(classifier.getId()) > -1)
    //             );
    //
    //             return of(result);
    //         }
    //         case MetaFieldType.MAIN_ENTITY: {
    //             const entityIds: number[] = entities.map(entity => entity.getProperty<number>(field.getSystemName()).value);
    //             if (this.entityCache.has(categorySystemName) && this.entityCache.get(categorySystemName).has(field.getCompoundCategorySystemName())) {
    //                 const result = this.entityCache.get(categorySystemName)
    //                     .get(field.getCompoundCategorySystemName())
    //                     .filter(entity => entityIds.indexOf(entity.getInstanceId()) > -1);
    //                 return of(result);
    //             }
    //
    //             return of(null);
    //         }
    //         case MetaFieldType.SUB_ENTITY: {
    //             return this._kbService.getMetaFields(field.getCompoundCategorySystemName()).pipe(
    //                 map((metaFields: MetaField[]) => {
    //                     const identifierField = metaFields.find(field => field.getType() === MetaFieldType.INTEGER_IDENTITY);
    //                     if (!isNil(identifierField)) {
    //                         if (this.subEntityCache.has(categorySystemName) && this.subEntityCache.get(categorySystemName).has(field.getCompoundCategorySystemName())) {
    //                             return entities.map(entity => {
    //                                 const subEntities = entity.getProperty<object[]>(field.getSystemName()).value;
    //                                 const subEntityIds = subEntities.map(subEntity => subEntity[identifierField.getSystemName()]);
    //                                 return this.subEntityCache.get(categorySystemName).get(field.getCompoundCategorySystemName()).filter(subEntity => subEntityIds.indexOf(subEntity.getId()) > -1);
    //                             });
    //                         }
    //                     }
    //                 })
    //             );
    //         }
    //         case MetaFieldType.LOOKUP: {
    //             const lookupCategorySystemName = field.getCompoundCategorySystemName();
    //             return this._kbService.getMetaFields(categorySystemName).pipe(
    //                 switchMap((metaFields: MetaField[]) =>
    //                     combineLatest(
    //                         entities.map((entity: Entity) => {
    //                             const lookupId = entity.getProperty<number>(
    //                                 field.getSystemName()
    //                             ).value;
    //                             if (!lookupId) {
    //                                 return of(undefined);
    //                             }
    //                             return this.extractLookupFromEntity(
    //                                 lookupCategorySystemName,
    //                                 lookupId,
    //                                 entity,
    //                                 metaFields
    //                             );
    //                         })
    //                     ).pipe(first())
    //                 )
    //             );
    //         }
    //         default: {
    //             throw new Error(
    //                 `Illegal field type ${field.getType()} was provided.`
    //             );
    //         }
    //     }
    // }
    DeSerializationService.prototype.deletedEntityFromAudit = function (mainEntityField, metaFields, entityInstanceId) {
        var deletedEntity$ = this._auditService.getEntityLastVersion(mainEntityField.getCompoundCategorySystemName(), entityInstanceId);
        return this.deserializeMainEntity(mainEntityField.getCompoundCategorySystemName(), deletedEntity$, null, true).pipe(operators_1.tap(function (entity) {
            entity.getProperty(metaFields
                .find(function (field) {
                return field.getType() ===
                    idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE;
            })
                .getSystemName()).value = entityInstanceId;
        }));
    };
    DeSerializationService.prototype.entityWithNoViewPermission = function (metaFields, entityInstanceId) {
        var value = {};
        value[metaFields
            .find(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE; })
            .getSystemName()] = entityInstanceId;
        return this._entityBuilder.createEntity(model_1.MainEntity, metaFields, value, false, true);
    };
    DeSerializationService.prototype.getEntitiesPermissions = function (systemName, entities, create) {
        if (create) {
            return this._dePermissionService
                .getPermissionValue(systemName, idm_authorization_client_js_1.PermissionType.ADD)
                .pipe(operators_1.map(function (permissions) { return [
                permissions,
            ]; }));
        }
        var instanceIds = [];
        var biggestInstanceId = -1;
        entities.forEach(function (entity) {
            var instanceId = entity.getInstanceId();
            instanceIds.push(instanceId);
            if (instanceId > biggestInstanceId) {
                biggestInstanceId = instanceId;
            }
        });
        var instanceIdsPerRequest = this.MAX_URL_LENGTH / (biggestInstanceId.toString().length + 1);
        if (entities.length <= instanceIdsPerRequest) {
            return this._dePermissionService.getCategoryDePermissionsByInstances(systemName, instanceIds);
        }
        else {
            var permissionsArray = [];
            var fromIndex = 0;
            var toIndex = instanceIdsPerRequest;
            while (toIndex < instanceIds.length) {
                permissionsArray.push(this._dePermissionService.getCategoryDePermissionsByInstances(systemName, instanceIds.slice(fromIndex, toIndex)));
                fromIndex = toIndex;
                toIndex += instanceIdsPerRequest;
            }
            permissionsArray.push(this._dePermissionService.getCategoryDePermissionsByInstances(systemName, instanceIds.slice(fromIndex, instanceIds.length)));
            return zip_1.zip.apply(void 0, permissionsArray).pipe(operators_1.map(function (permissionsArrays) {
                return [].concat.apply([], permissionsArrays);
            }));
        }
    };
    DeSerializationService.prototype.getSerializedFieldsObservables = function (entityFields, entity, languages) {
        var _this = this;
        return entityFields.map(function (field) {
            var fieldName = field.getSystemName();
            var fieldType = field.getType();
            var fieldValue = entity.getProperty(fieldName).value;
            if (fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
                return fieldValue.length === 0
                    ? of_1.of(fieldValue)
                    : _this.serializeSubEntities(field.getCompoundCategorySystemName(), fieldValue);
            }
            else if (fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY) {
                return fieldValue === null
                    ? of_1.of(null)
                    : of_1.of(fieldValue.getInstanceId());
            }
            else {
                return of_1.of(idm_de_core_frontend_1.serializeSimpleField(field, fieldValue, languages));
            }
        });
    };
    DeSerializationService.prototype.makeEntityData = function (entityFields, entityFieldsData, permissions) {
        var _this = this;
        var entityData = {};
        if (!permissions) {
            this.addAllFields(entityFields, entityFieldsData, entityData);
        }
        else if (permissions instanceof model_1.DePermission) {
            this.addPermittedFields(entityFields, entityFieldsData, permissions.viewableFields, entityData);
        }
        else {
            permissions.forEach(function (categoryPermissions) {
                if (categoryPermissions.access === idm_authorization_client_js_1.Access.FULL) {
                    _this.addAllFields(entityFields, entityFieldsData, entityData);
                }
                else if (categoryPermissions.access === idm_authorization_client_js_1.Access.CUSTOM) {
                    if (lodash_1.isNil(categoryPermissions.customValues.fields)) {
                        _this.addAllFields(entityFields, entityFieldsData, entityData);
                    }
                    else {
                        var permissibleFields = Array.from(categoryPermissions.customValues.fields.values()).map(function (fieldName) { return fieldName.toString(); });
                        _this.addPermittedFields(entityFields, entityFieldsData, permissibleFields, entityData);
                    }
                }
            });
        }
        if (Object.keys(entityData).length === 0) {
            var error = new Error('No permission for the entity');
            error['status'] = 403;
            throw error;
        }
        return entityData;
    };
    DeSerializationService.prototype.addAllFields = function (entityFields, entityFieldsData, entityData) {
        entityFields.forEach(function (field, index) {
            entityData[field.getSystemName()] = entityFieldsData[index];
        });
    };
    DeSerializationService.prototype.addPermittedFields = function (entityFields, entityFieldsData, permittedFieldNames, entityData) {
        entityFields.forEach(function (field, index) {
            if (permittedFieldNames.indexOf(field.getMetaFieldId().getSystemName()) !== -1) {
                entityData[field.getSystemName()] = entityFieldsData[index];
            }
            else if (field.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
                // All sub entities should always be present at least as empty arrays
                entityData[field.getSystemName()] = [];
            }
            else if (field.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
                // All multilingual strings should always be present at least as empty objects
                entityData[field.getSystemName()] = {};
            }
        });
    };
    DeSerializationService.prototype.throwNoLookupError = function (lookupCategorySystemName, lookupId) {
        throw new Error("No lookup sub entity found with " + lookupId + " id and " + lookupCategorySystemName + " category");
    };
    DeSerializationService.prototype.uniqueFilter = function (value, index, self) {
        return self.indexOf(value) === index;
    };
    DeSerializationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_classifier_service_client_js_1.ClassifierService,
            service_1.DePermissionService,
            service_1.DeService,
            idm_classifier_service_client_js_1.EntityAuditService,
            core_1.NgZone])
    ], DeSerializationService);
    return DeSerializationService;
}());
exports.DeSerializationService = DeSerializationService;
function mapAddSet(mapToAdd, key, value) {
    if ((Array.isArray(value) && !lodash_1.isEmpty(value)) ||
        (!Array.isArray(value) && !lodash_1.isNil(value))) {
        if (!mapToAdd.has(key)) {
            if (Array.isArray(value)) {
                mapToAdd.set(key, new Set(value));
            }
            else {
                mapToAdd.set(key, new Set([value]));
            }
        }
        else {
            if (Array.isArray(value)) {
                value.forEach(function (v) { return mapToAdd.get(key).add(v); });
            }
            else {
                mapToAdd.get(key).add(value);
            }
        }
    }
}
function mapAddArray(mapToAdd, key, value) {
    if ((Array.isArray(value) && !lodash_1.isEmpty(value)) ||
        (!Array.isArray(value) && !lodash_1.isNil(value))) {
        if (!mapToAdd.has(key)) {
            if (Array.isArray(value)) {
                mapToAdd.set(key, value);
            }
            else {
                mapToAdd.set(key, [value]);
            }
        }
        else {
            if (Array.isArray(value)) {
                value.forEach(function (v) { return mapToAdd.get(key).push(v); });
            }
            else {
                mapToAdd.get(key).push(value);
            }
        }
    }
}
function mapCheckAddSet(mapToAdd, mapToCheck, key, value) {
    if ((Array.isArray(value) && !lodash_1.isEmpty(value)) ||
        (!Array.isArray(value) && !lodash_1.isNil(value))) {
        if (!mapToCheck.has(key)) {
            mapAddSet(mapToAdd, key, value);
        }
        else {
            if (Array.isArray(value)) {
                var aptValues = value.filter(function (v) { return !mapToCheck.get(key).has(v); });
                mapAddSet(mapToAdd, key, aptValues);
            }
            else {
                if (!mapToCheck.get(key).has(value)) {
                    mapAddSet(mapToAdd, key, value);
                }
            }
        }
    }
}
function getOrDefault(map, key, defaultFn) {
    if (!map.has(key)) {
        map.set(key, defaultFn());
    }
    return map.get(key);
}
//# sourceMappingURL=de-serialization.service.js.map